<template>
	<div class="user-center">
		<a href="javascript:;" class="scan-btn" @click="scanQRCode" v-if="is_weix"><img src="../../assets/images/scan.png" alt=""></a>
		<div class="bg">
			<div class="divider"></div>
		</div>
		<div class="header">
			<div v-if="UserInfo.user.user_role == 2">
				<nut-avatar
					class="avatar"
					bg-icon
					:bg-image="
						UserInfo == undefined || UserInfo.length <= 0
							? require('@/assets/images/m_photo.png')
							: UserInfo.user.store.store_avatar
					"
					@active-avatar="handleNavigateToInfo"
				></nut-avatar>
			</div>
			<div v-else>
				<nut-avatar
					class="avatar"
					bg-icon
					:bg-image="
						UserInfo == undefined || UserInfo.length <= 0
							? require('@/assets/images/m_photo.png')
							: UserInfo.user.head_pic
					"
					@active-avatar="handleNavigateToInfo"
				></nut-avatar>
			</div>

			<a
				v-if="UserInfo == undefined || UserInfo.length <= 0"
				href="/m/User/login?reurl=/?id=590#/user"
				class="info"
			>
				<span class="v-a-middle">
					<p class="bold">马上登录</p>
				</span>
				<nut-icon class="icon v-a-middle" type="right" size="10px"></nut-icon>
			</a>
			<!--<a v-else href="javascript:;" @click="UserInfo.user.user_role !== 3 ? $router.push({ path: '/user-info'}) : $router.push({ path: '/instructor-info'})" class="info">-->
			<a
				v-else
				href="javascript:;"
				@click="$router.push({ name: 'InstructorInfo' })"
				class="info"
			>
				<span class="v-a-middle">
					<!--普通人显示昵称/教练显示昵称+驾校名+教龄/驾校显示驾校名-->
					<p class="bold" v-if="UserInfo.user.user_role == 1 || UserInfo.user.user_role == 3">{{ UserInfo.user.nickname }}</p>
					<p class="bold" v-else-if="UserInfo.user.user_role == 2">{{ UserInfo.userData.userStore }}</p>
					<template v-if="UserInfo.user.user_role == 3">
						<p class="small">
							{{ UserInfo.userData.userStore }}| {{ UserInfo.user.adviser.level_category }}年驾龄
						</p>
					</template>
				</span>
				<nut-icon v-if="UserInfo.user.user_role !== 2" class="icon v-a-middle" type="right" size="10px"></nut-icon>
			</a>
		</div>

		<!-- 累计收益 / 可提现收益 -->
		<div class="data-panel">
			<ul>
				<li>
					<p>
						余额（元）
						<img
							src="../../assets/images/yanjing.png"
							class="eye-icon"
							@click="handleHideData"
						/>
					</p>
					<p class="blue big money">{{ i_money }}</p>
				</li>
				<!-- <li style="margin-top: 10px">
					<p>可提现收益（元）</p>
					<p class="blue small money">{{ o_moneny }}</p>
				</li> -->
			</ul>

			<a
				href="javascript:;"
				class="go2fenxiao"
				@click="$router.push({ name: 'SaleCenter' })"
			>
				<span class="v-a-middle">我的钱包</span>
				<nut-icon class="icon v-a-middle" type="right" size="10px"></nut-icon>
			</a>
		</div>

		<!--商家门店中心-->
		<div class="my-extra card" style="margin-top:14px" v-if="is_boss===2" @click="storeCenter">
			<a
				href="javascript:;"
				class="cell flex a-center"
			>
				<img
					slot="avatar"
					src="../../assets/images/mendian.png"
					class="v-a-top icon"
				/>
				<span class="title" 
					>商家门店中心</span
				>
				<img class="right" src="../../assets/images/xiangxia@2x.png" alt="" />
			</a>
		</div>

		<!--养车vip-->
		<div class="my-order card 1" v-if="is_boss===1">
			<div class="flex j-between title">
				<b>养车服务</b>
				<a href="javascript:;">
					<span class="v-a-middle" @click="navigateToMaintain"
						>养车VIP</span
					>
					<nut-icon class="icon v-a-middle" type="right" size="10px"></nut-icon>
				</a>
			</div>

			<nut-row>
				<nut-col :span="UserInfo.user.maintain_vip==1?8:12" >
					<a
						href="javascript:;"
						class="flex-content"
						@click="scanQRCode"
					>
						<nut-badge class="item">
							<img src="../../assets/images/smzf.png" alt="待付款" />
						</nut-badge>
						<p>扫码支付</p>
					</a>
				</nut-col>

				<nut-col :span="8" v-if="UserInfo.user.maintain_vip==1">
					<a
						href="javascript:;"
						class="flex-content"
						@click="$router.push({ name: 'MaintainVipCode', query: { nickname: UserInfo.user.nickname,mobile:UserInfo.user.mobile  } })"
					>
						<nut-badge class="item">
							<img src="../../assets/images/skm.png" alt="我的会员码" />
						</nut-badge>
						<p>我的会员码</p>
					</a>
				</nut-col>

				<nut-col :span="8">
					<a
						href="javascript:;"
						class="flex-content"
						@click="$router.push({ name: 'SaleDetail', query: { type: '7-8'  } })"
					>
						<nut-badge  class="item">
							<img src="../../assets/images/xfjl.png" alt="消费记录" />
						</nut-badge>
						<p>消费记录</p>
					</a>
				</nut-col>
			</nut-row>
		</div>

		<div class="my-order card 2" v-if="is_boss===2">
			<div class="flex j-between title">
				<b>养车服务</b>
				<a href="javascript:;">
					<span class="v-a-middle" @click="navigateToMaintain"
						>养车VIP</span
					>
					<nut-icon class="icon v-a-middle" type="right" size="10px"></nut-icon>
				</a>
			</div>

			<nut-row>
				<nut-col :span="UserInfo.user.maintain_vip==1?6:8" >
					<a
						href="javascript:;"
						class="flex-content"
						@click="scanQRCode"
					>
						<nut-badge class="item">
							<img src="../../assets/images/smzf.png" alt="待付款" />
						</nut-badge>
						<p>扫码支付</p>
					</a>
				</nut-col>

				<nut-col :span="UserInfo.user.maintain_vip==1?6:8">
					<a
						href="javascript:;"
						class="flex-content"
						@click="$router.push({ name: 'SaleDetail', query: { type: '7-8'  } })"
					>
						<nut-badge class="item">
							<img src="../../assets/images/xfjl.png" alt="消费记录" />
						</nut-badge>
						<p>消费记录</p>
					</a>
				</nut-col>
				<nut-col :span="6" v-if="UserInfo.user.maintain_vip==1">
					<a
						href="javascript:;"
						class="flex-content"
						@click="$router.push({ name: 'MaintainVipCode' , query: { nickname: UserInfo.user.nickname,mobile:UserInfo.user.mobile  }})"
					>
						<nut-badge  class="item">
							<img src="../../assets/images/skm.png" alt="收款码" />
						</nut-badge>
						<p>我的会员码</p>
					</a>
				</nut-col>
				<nut-col :span="UserInfo.user.maintain_vip==1?6:8">
					<a
						href="javascript:;"
						class="flex-content"
						@click="$router.push({ name: 'SaleDetail', query: { type: '9'  } })"
					>
						<nut-badge class="item">
							<img src="../../assets/images/skjl.png" alt="收款记录" />
						</nut-badge>
						<p>收款记录</p>
					</a>
				</nut-col>
			</nut-row>
		</div>


		

		<!-- 我的订单 -->
		<div class="my-order card">
			<div class="flex j-between title">
				<b>我的订单</b>
				<a href="javascript:;">
					<span class="v-a-middle" @click="$router.push({ name: 'MyOrder' })"
						>查看全部订单</span
					>
					<nut-icon class="icon v-a-middle" type="right" size="10px"></nut-icon>
				</a>
			</div>

			<nut-row>
				<nut-col :span="6">
					<a
						href="javascript:;"
						class="flex-content"
						@click="$router.push({ name: 'MyOrder', query: { type: 1 } })"
					>
						<nut-badge :value="UserInfo.unpaid_order" class="item">
							<img src="../../assets/images/daifukuan.png" alt="待付款" />
						</nut-badge>
						<p>待付款</p>
					</a>
				</nut-col>
				<nut-col :span="6">
					<a
						href="javascript:;"
						class="flex-content"
						@click="$router.push({ name: 'MyOrder', query: { type: 2 } })"
					>
						<nut-badge :value="UserInfo.going_order" class="item">
							<img src="../../assets/images/daishouhuo.png" alt="进行中" />
						</nut-badge>
						<p>进行中</p>
					</a>
				</nut-col>
				<nut-col :span="6">
					<a
						href="javascript:;"
						class="flex-content"
						@click="$router.push({ name: 'MyOrder', query: { type: 3 } })"
					>
						<nut-badge :value="UserInfo.completed_order" class="item">
							<img src="../../assets/images/yiwancheng.png" alt="已完成" />
						</nut-badge>
						<p>已完成</p>
					</a>
				</nut-col>
				<nut-col :span="6">
					<a
						href="javascript:;"
						class="flex-content"
						@click="$router.push({ name: 'MyOrder', query: { type: 4 } })"
					>
						<nut-badge :value="UserInfo.cancel_order" class="item">
							<img
								src="../../assets/images/shouhoutuikuan.png"
								alt="过期/退款"
							/>
						</nut-badge>
						<p>过期/退款</p>
					</a>
				</nut-col>
			</nut-row>
		</div>

    <!-- <div class="fenxiao" @click="$router.push({ name: 'SharePoster' })" v-if="show_fenxiao">
      <img  src="../../assets/images/placeholder-1.png" alt="">
    </div> -->


		<!-- 我的卡券 / 我的奖品 / 我的收藏 -->
		<div class="my-other card">
			<nut-row class="m-nut-row">
				<nut-col :span="8">
					<a
						href="javascript:;"
						class="wrap"
						@click="$router.push({ name: 'MyVoucher' })"
					>
						<img src="../../assets/images/A_2.png" alt="" />
					</a>
					<p @click="$router.push({ name: 'MyVoucher' })">我的卡券</p>
				</nut-col>
				<nut-col :span="8">
					<a
						href="javascript:;"
						class="wrap"
						@click="$router.push({ name: 'MyGift' })"
					>
						<img src="../../assets/images/A_1.png" alt="" />
					</a>
					<p @click="$router.push({ name: 'MyGift' })">我的奖品</p>
				</nut-col>
				<nut-col :span="8">
					<a
						href="javascript:;"
						class="wrap"
						@click="$router.push({ name: 'MyCollection' })"
					>
						<img src="../../assets/images/A.png" alt="" />
					</a>
					<p @click="$router.push({ name: 'MyCollection' })">我的收藏</p>
				</nut-col>
				<nut-col v-if="UserInfo.user.user_role == 2" :span="8">
					<a
						href="javascript:;"
						class="wrap"
						@click="$router.push({ name: 'ExchangeCenter' })"
					>
						<img src="../../assets/images/A_J.png" alt="" />
					</a>
					<p @click="$router.push({ name: 'ExchangeCenter' })">兑奖中心</p>
				</nut-col>
			</nut-row>
		</div>
		<!-- 驾校合作 / 推荐APP给好友 -->
		<div class="my-extra card" v-show="UserInfo.user.user_role == 1">
			<a
				href="javascript:;"
				class="cell flex a-center"
				
			>
				<img
					slot="avatar"
					src="../../assets/images/icon_bangzhuwendang.png"
					class="v-a-top icon"
				/>
				<span class="title" @click="$router.push({ name: 'ApplicationIn' })"
					>驾校合作</span
				>
				<img class="right" src="../../assets/images/xiangxia@2x.png" alt="" />
			</a>
			<!-- <a href="javascript:;" class="cell flex a-center">
				<img
					slot="avatar"
					src="../../assets/images/fabu.png"
					class="v-a-top icon"
				/>
				<span class="title" @click="$router.push({ name: 'SharePoster' })"
					>推荐给好友</span
				>
				<img class="right" src="../../assets/images/xiangxia@2x.png" alt="" />
			</a> -->
		</div>

		<nut-popup
			:style="{ width: '280px', height: '240px' }"
			v-model="show"
			closeable
			class="my-popup"
		>
			<div class="popup-wrap">
				<p class="name">参与“逛滨湖公园”的拼单</p>
				<p class="desc">仅剩2个名额，23:34:12后结束</p>

				<div class="flex j-center">
					<nut-avatar class="avatar" bg-icon bg-image="https://dss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3452544685,1844225866&fm=26&gp=0.jpg"></nut-avatar>
					<nut-avatar class="avatar" bg-icon :bg-image="require('../../assets/images/？.png')"></nut-avatar>
					<nut-avatar class="avatar" bg-icon :bg-image="require('../../assets/images/？.png')"></nut-avatar>
				</div>

				<nut-button shape="circle" class="button">参与拼单</nut-button>
			</div>
		</nut-popup>
	</div>
</template>

<script>
import anime from 'animejs'
import cache from "../../utils/cache";
import {Toast} from '@nutui/nutui' // 传送门 http://nutui.jd.com/#/toast
export default {
	name: 'user',
	metaInfo: {
		title: '我的',
		titleTemplate: null,
	},
	components: {
	},
	data: () => ({
		isHide: false,
		input_money: '00.000.00',
		can_out_money: '00.000.00',
		UserInfo: {
			user: {
				adviser: {},
			},
			userData: {},
		},
		id: '',
		// 拼团弹窗
		show: false,
		is_weix:false,
		show_fenxiao: false,
		is_boss:0
	}),
	computed: {
		i_money() {
			return this.isHide ? '** *** ***' : this.input_money
		},
		o_moneny() {
			return this.isHide ? '** *** **' : this.can_out_money
		},
	},
	created() {
		//活动ID
		var id = this.$ajax.get_activity_id()
		this.id = id

		//用户信息
		this.$ajax.get('m/trade/my?id=' + id, {}).then((res) => {
			this.UserInfo = res
			this.input_money = res.wallet.total_amount
			this.can_out_money = res.wallet.money
			this.show_fenxiao = parseInt(res.activity_info.distribut_reward_status) ===0 ? false : true;
			this.is_boss = parseInt(res.business_id) >0 ? 2 : 1;
		})
		//获取用户微信环境
		this.environment_info();
		if (/MicroMessenger/i.test(navigator.userAgent)) {
			this.getWechartConfig();
		}
		
	},
	methods: {
		handleHideData() {
			this.isHide = !this.isHide
		},

		handleNavigateToInfo() {
			// this.$router.push({ name: 'UserInfo' })
			if(this.UserInfo.user.user_role !== 2){
				this.$router.push({ name: 'InstructorInfo' })
			}
		},
		scanQRCode(){
			if(this.is_weix){
				wx.scanQRCode({
					needResult : 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果.核销码本质是一个url,直接微信处理跳转就行
					scanType : [ "qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
					success : function(res) {
						var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
						if(result){
							window.location.href = result;//扫描后为链接，跳转
						}
						
					}
				});
			}else{
				Toast.text('请自行调用APP扫码功能或打开微信扫一扫');
			}
			
		},
		environment_info(){
			var info = cache.get('environment_info');
			if(info == null){
				this.$ajax.get('/m/trade/get_environment_info',{}).then(re=>{
					this.is_weix = re.is_wx
					cache.set('environment_info',JSON.stringify(re))
				})
			}else {
				info = JSON.parse(info);
				this.is_weix = info.is_wx;
			}
		},
		navigateToMaintain(){
			var host = window.location.host;
			 window.location.href = 'http://'+host+'/maintain/#/';
		},

		storeCenter(){
			var host = window.location.host;
            window.location.href = 'http://'+host+'/maintain/#/pages/store-center/store-center';
		},

		getWechartConfig(){
			this.$ajax.get('http://auth.ccoojkm.cn/api/wechat/getWxConfig', {
				 uid:1507,
				dtype:1,
				source:1,
				formurl:window.location.href
			}).then((res) => {
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: res.appId, // 必填，公众号的唯一标识
					timestamp: res.timestamp, // 必填，生成签名的时间戳
					nonceStr: res.nonceStr, // 必填，生成签名的随机串
					signature: res.signature,// 必填，签名
					jsApiList: [
				                'checkJsApi',
				                'onMenuShareTimeline',
				                'onMenuShareAppMessage',
								'scanQRCode',
								'getLocation',
								'openLocation',
				            ] // 必填，需要使用的JS接口列表
				});
		})
		}
	},
}
</script>

<style lang="less" scoped>
@import './index.less';
.fenxiao{
  margin: 0 14px;
  img{
    width: 100%;
  }
}

.my-order{
  margin: 15px 14px;
  a {
    img{
      width: 25px;
      height: 25px;
    }
  }
}
.my-other{
  a {
    img{
      width: 25px;
      height: 25px;
    }
  }
}
.my-extra {
  a {
    img{
      width: 25px;
      height: 25px;
    }
  }
}
.v-a-middle {
	display: inline-block;
	vertical-align: middle;
}
.v-a-top {
	display: inline-block;
	vertical-align: top;
}
.money {
	transform-origin: center;
}
.m-nut-row {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.my-popup {
	.popup-wrap {
		padding: 40px 30px 30px 30px;
		text-align: center;
		line-height: 1.5em;
	}
	.name {
		font-size: 15px;
		color: #333333;
		font-weight: 400;
	}
	.desc {
		font-size: 11px;
		color: #999999;
	}
	.avatar {
		width: 40px;
		height: 40px;
		margin-right: 20px;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	.avatar:last-child {
		margin-right: 0;
	}

	.button {
		width: 160px;
		height: 40px;
		font-weight: bold;
		background: linear-gradient(
			45deg,
			rgba(60, 67, 236, 1) 0%,
			rgba(0, 194, 255, 1) 100%
		);
	}
}

.scan-btn {
	position: absolute;
	right: 14px;
	top: 10px
}

</style>
